import styled from "styled-components";

/**
 * 部品選択ダイアログのスタイル
 * 2026-09-11 tdaig No.56
 */
const SearchPartsStyles = {
  Wrap: styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    font-size: 13px;
    color: #334155;
  `,
  /*
   * 2026-09-16 tdaig
   * タイトル先頭の赤スパナ（No.56 ダイアログイメージに合わせる）
   */
  Title: styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
  `,
  /*
   * 2026-09-16 tdaig
   * タイトル行を左右に分け、閉じるボタンの左に選択件数を置く
   */
  TitleBar: styled.span`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 12px;
    padding-right: 8px;
  `,
  TitleSelected: styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 500;
    color: #334155;
    white-space: nowrap;
    svg {
      font-size: 18px;
    }
  `,
  TitleSelectedCount: styled.span`
    color: #ef4444;
    font-weight: 700;
    margin: 0 1px;
  `,
  TitleWrench: styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    flex-shrink: 0;
    border-radius: 6px;
    background: #ef4444;
    &::before {
      content: "";
      display: block;
      width: 16px;
      height: 16px;
      background-color: #fff;
      mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='black' d='M22.7 19.4l-1.4 1.4c-.39.39-1.02.39-1.41 0L13.8 14.7a6.5 6.5 0 01-8.5-8.5l3.5 3.5 2.12-.71.71-2.12-3.5-3.5a6.5 6.5 0 018.5 8.5l6.07 6.07c.39.39.39 1.02 0 1.41z'/%3E%3C/svg%3E")
        center / contain no-repeat;
      -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='black' d='M22.7 19.4l-1.4 1.4c-.39.39-1.02.39-1.41 0L13.8 14.7a6.5 6.5 0 01-8.5-8.5l3.5 3.5 2.12-.71.71-2.12-3.5-3.5a6.5 6.5 0 018.5 8.5l6.07 6.07c.39.39.39 1.02 0 1.41z'/%3E%3C/svg%3E")
        center / contain no-repeat;
    }
  `,
  Toolbar: styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
    flex-shrink: 0;
  `,
  /*
   * 2026-09-16 tdaig
   * キーワード入力の先頭に検索アイコンを置く
   */
  KeywordWrap: styled.span`
    position: relative;
    display: inline-flex;
    align-items: center;
    input {
      padding-left: 28px;
    }
  `,
  KeywordIcon: styled.span`
    position: absolute;
    left: 6px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    display: inline-flex;
    align-items: center;
    color: #94a3b8;
    line-height: 1;
    svg {
      font-size: 18px;
    }
  `,
  Body: styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1.4fr) minmax(280px, 0.8fr);
    gap: 12px;
    overflow: hidden;
    min-height: 0;
    align-items: stretch;
  `,
  LeftPane: styled.div`
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    min-height: 0;
  `,
  /*
   * 2026-09-14 tdaig
   * 右枠の内容量でグリッド行が伸びないようにする（左の検索結果一覧の高さを維持）
   */
  RightPane: styled.div`
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 0;
    min-height: 100%;
    background: #f8fafc;
  `,
  PaneHeader: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 8px 10px;
    background: #f1f5f9;
    border-bottom: 1px solid #e2e8f0;
    font-weight: 600;
    flex-shrink: 0;
  `,
  CountBadge: styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 20px;
    padding: 0 6px;
    margin-left: 6px;
    border-radius: 10px;
    background: #1d4ed8;
    color: #fff;
    font-size: 11px;
  `,
  /*
   * 2026-09-16 tdaig
   * ヘッダ1行 + データ10行が枠内に収まる高さ（スクロールなし）
   * 行高を少し伸ばしたため 480px（ヘッダ40 + データ44×10）
   */
  TableWrap: styled.div`
    flex: 0 0 480px;
    height: 480px;
    overflow: hidden;
    background: #fff;
  `,
  Table: styled.table`
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    font-size: 12px;
    th,
    td {
      padding: 0 10px;
      height: 44px;
      border-bottom: 1px solid #e2e8f0;
      text-align: left;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    thead th {
      height: 40px;
    }
    th:first-child,
    td:first-child {
      width: 36px;
    }
    /*
     * 2026-09-14 tdaig
     * 大分類は「タイヤ・ホイール」が省略されない幅。部位は部品名を優先して狭める
     */
    th:nth-child(2),
    td:nth-child(2) {
      width: 132px;
    }
    th:nth-child(3),
    td:nth-child(3) {
      width: 88px;
    }
    th:last-child,
    td:last-child {
      width: 88px;
    }
    th {
      background: #f8fafc;
      color: #475569;
      font-weight: 600;
    }
    tr.selected {
      background: #eff6ff;
    }
  `,
  SelectedMark: styled.span`
    color: #2563eb;
    font-size: 12px;
    font-weight: 600;
  `,
  Empty: styled.div`
    padding: 24px 12px;
    text-align: center;
    color: #94a3b8;
  `,
  Pager: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 10px;
    border-top: 1px solid #e2e8f0;
    background: #fff;
    font-size: 12px;
    flex-shrink: 0;
  `,
  PagerBtns: styled.div`
    display: flex;
    gap: 4px;
    button {
      min-width: 32px;
      height: 26px;
      min-height: 26px;
      padding: 0 6px;
    }
    /*
     * 2026-09-16 tdaig
     * 現在ページだけ青、それ以外は白（outlined）
     */
    button.MuiButton-outlined {
      background: #fff;
      color: #334155;
      border-color: #cbd5e1;
    }
    button.MuiButton-contained,
    button.current {
      background: #2563eb;
      color: #fff;
      border-color: #2563eb;
    }
  `,
  /*
   * 2026-09-15 tdaig
   * 選択済み絞り込みは formProps.input を使う。枠の余白だけここで持つ
   */
  SelectedFilterWrap: styled.div`
    margin: 8px 10px 0;
    flex-shrink: 0;
  `,
  /*
   * 2026-09-14 tdaig
   * ダイアログ全体はスクロールせず、選択済み部品が溢れたときだけこの枠をスクロールする
   */
  SelectedList: styled.div`
    flex: 1;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 8px 10px 10px;
  `,
  SelectedItem: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 8px;
    margin-bottom: 8px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
  `,
  SelectedMeta: styled.div`
    font-size: 11px;
    color: #64748b;
    margin-bottom: 2px;
  `,
  SelectedName: styled.div`
    font-weight: 600;
    color: #0f172a;
  `,
  Hint: styled.div`
    margin: 10px 10px 12px;
    padding: 8px 10px;
    border-radius: 4px;
    background: #eff6ff;
    color: #1e40af;
    font-size: 11px;
    flex-shrink: 0;
  `,
  Footer: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin-top: 12px;
    flex-shrink: 0;
  `,
  FooterNote: styled.p`
    margin: 0;
    font-size: 11px;
    color: #64748b;
  `,
  FooterBtns: styled.div`
    display: flex;
    gap: 8px;
    /*
     * 2026-09-16 tdaig
     * フッターのキャンセルは白（outlined）
     */
    button.MuiButton-outlined {
      background: #fff;
      color: #334155;
      border-color: #cbd5e1;
    }
  `,
  Overlay: styled.div`
    position: absolute;
    inset: 0;
    background: rgba(15, 23, 42, 0.35);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 5;
  `,
  ConfirmBox: styled.div`
    width: 420px;
    max-width: calc(100% - 24px);
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 10px 30px rgba(15, 23, 42, 0.2);
    padding: 20px 20px 16px;
  `,
  ConfirmTitle: styled.div`
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 10px;
  `,
  ConfirmText: styled.p`
    margin: 0 0 8px;
    font-size: 13px;
    line-height: 1.6;
  `,
  ConfirmHint: styled.div`
    margin: 12px 0 16px;
    padding: 8px 10px;
    border-radius: 4px;
    background: #f1f5f9;
    font-size: 12px;
    color: #475569;
  `,
  ConfirmActions: styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  `,
};

export default SearchPartsStyles;
